import React from 'react';
import Slider from "react-slick/lib";
import { Line } from "../../Common";
import { Image } from '../../Common';
import { documentsOpts } from '../SliderConfig';

function Documents() {
  return (
    <Line
      title="Документы"
      style={{ margin: '0 auto', marginBottom: '2rem'}}
    >
      <div className="carouselcont">
        <Slider {...documentsOpts}>
          <div className="documents__slider">
            <Image
              src="/documents/licence_1.jpg"
              thumb="/documents/licence_1-low.jpg"
            />
          </div>
          <div className="documents__slider">
            <Image
              src="/documents/licence_2.jpg"
              thumb="/documents/licence_2-low.jpg"
            />
          </div>
          <div className="documents__slider">
            <Image
              src="/documents/annex.jpg"
              thumb="/documents/annex-low.jpg"
            />
          </div>
        </Slider>
      </div>
    </Line>
  );
}


export default Documents;



// WEBPACK FOOTER //
// ./src/components/About/Common/Documents.jsx